import React from "react";
import FridgePageTemplate from "./FridgePageTemplate";

const relatedLinks = [
  { to: "/fridge-service-bangalore", label: "Refrigerator Service" },
  { to: "/double-door-refrigerator-service-bangalore", label: "Double Door Service" },
  { to: "/freezer-cooling-issue", label: "Freezer Cooling Issue" },
  { to: "/fridge-compressor-repair", label: "Compressor Repair" },
];

const SideBySideFridgeService = () => (
  <FridgePageTemplate
    title="Side-by-Side Fridge Service in Bangalore"
    description="Side-by-side refrigerator repair in Bangalore for cooling, freezer, compressor, and water leakage issues."
    keywords="side by side fridge service bangalore, side by side refrigerator repair, fridge repair"
    path="/side-by-side-fridge-service-bangalore"
    bannerTitle="Side-by-Side Fridge Service"
    intro="Our technicians provide doorstep service for side-by-side refrigerators across Bangalore."
    highlights={[
      "Freezer and refrigerator cooling checks",
      "Compressor and fan motor diagnostics",
      "Water leakage and drain line service",
      "Sensor and control panel troubleshooting",
    ]}
    issues={[
      "Freezer not cooling",
      "Uneven temperature",
      "Ice buildup",
      "Water leakage",
    ]}
    relatedLinks={relatedLinks}
  />
);

export default SideBySideFridgeService;
